import { CountryCode } from './type';
import type { Country } from './type';

export const benelux: Country = {
    name: 'Benelux',
    nameFull: 'Benelux',
    code: CountryCode.BE,
    displayCode: CountryCode.BX,
    combinedDisplayCode: CountryCode.BENELUX,
    makeMethod: 'makeBenelux',
    theme: false,
    currency: '€ ',
    currencyName: 'EUR ',
    currencyWithCountry: '€ ',
    maxImageSize: 20000000, // 20MB
    imageOptions: {
        maxSize: 20000000,
        fileType: []
    },
    maxGoodNumberPerClass: 100,
    paymentMethodsImageName: 'image-4-card',
    stripeKey: import.meta.env.VITE_STRIP_PUBLIC_KEY_BX,
    autoSelectedInForm: false,
};
